export default __webpack_public_path__ + "static/media/kabalithumb.6cd5336a.jpg";